export const TEXT_BACKGROUND_SLICE_TYPE = 'solution_text_background';

export enum SPACING {
  LOW = 'Low',
  HIGH = 'High',
}
